import React, { useState, useEffect } from "react";
import "./Upgrades.scss";


interface subscriptions_types {
  id: number;
  name: string;
  tokens: number;
  price: string;
  description: string;
}

//const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000/api";

const Subs: React.FC = () => {
  //subscriptions_types (backend)
  const [subscriptions_types, setSubscriptionsTypes] = useState<subscriptions_types[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const [totalTokens, setTotalTokens] = useState(900);
  const isVerified = true; // Hardcoded as true for now

  useEffect(() => {
    const controller = new AbortController();
    const load = async () => {
      try {
        setLoading(true);
        const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/subscription_types`, { signal: controller.signal });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data: subscriptions_types[] = await res.json();
        setSubscriptionsTypes(data);
      } catch (err: any) {
        if (err.name !== "AbortError") setError(err.message || "Failed to load subscriptions");
      } finally {
        setLoading(false);
      }
    };
    load();
    return () => controller.abort();
  }, []);

  const handleClick = (tokens: number) => {
    if (isVerified) {
      setTotalTokens((prev) => prev + tokens);
    } else {
      alert("User not verified!");
    }
  };

  return (
    <div className="subs-container">
      <h1 className="title">Choose Your Subscription</h1>

      {loading && <div>Loading subscriptions…</div>}
      {error && <div className="error">Error: {error}</div>}

      <div className="subs-grid">
        {!loading && subscriptions_types.length === 0 && <div>No subscriptions available.</div>}
        {subscriptions_types.map((sub) => (
          <div key={sub.id} className="sub-card">
            <h2>{sub.name}</h2>
            <p className="desc">{sub.description}</p>
            <p className="tokens">Tokens: {sub.tokens}</p>
            <p className="price">Price: {sub.price}</p>
            <button className="choose-btn" onClick={() => handleClick(sub.tokens)}>
              Select
            </button>
          </div>
        ))}
      </div>

      <div className="total-tokens">
        Current Tokens: <span>{totalTokens}</span>
      </div>
    </div>
  );
};

export default Subs;
